import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';

import ProfileForm from './ProfileForm';
import { ConfirmModal } from '../../Modals';
import { updateInfo, uploadFile } from '../../../../actions';

class Profile extends Component {
  state = {
    fields: {
      newPassword: {
        value: '',
      },
      newFullname: {
        value: this.props.info.fullname,
      },
      newEmail: {
        value: this.props.info.email,
      },
      newWebsite: {
        value: this.props.info.website,
      },
      newPhone: {
        value: this.props.info.phone,
      },
      newResearchField: {
        value: this.props.info.researchField,
      },
      newJournal: {
        value: this.props.info.journal,
      },
      newTextbook: {
        value: this.props.info.textbook,
      },
      newProject: {
        value: this.props.info.project,
      },
      newDegree: {
        value: this.props.info.degree,
      },
      newMajor: {
        value: this.props.info.major,
      },
      newAcademicRank: {
        value: this.props.info.academicRank,
      },
      newAvatar: {
        value: this.props.info.avatar,
      },
      newAchievements: {
        value: this.props.info.achievements,
      },
    },
    confirmModalVisible: false,
  };

  componentDidMount() {
    // const lecturerId = this.props.info.lecturerId;
    // this.props.updateInfo({
    //   lecturerId,
    // });
  }

  handleFormChange = (changedFields) => {
    this.setState(({ fields }) => ({
      fields: { ...fields, ...changedFields },
    }));
  }

  showConfirmModal = () => {
    this.setState({
      confirmModalVisible: true,
    });
  }

  closeCofirmModal = () => {
    this.setState({
      confirmModalVisible: false,
      fields: {
        ...this.state.fields,
        newPassword: {
          value: '',
        },
      },
    });
  }

  handleConfirm = () => {
    const {
      info: {
        lecturerId,
        fullname,
        phone,
        researchField,
        email,
        website,
        avatar,
        academicRank,
        degree,
        textbook,
        journal,
        project,
        major,
        achievements,
      },
    } = this.props;
    const {
      fields: {
        newPassword,
        newFullname,
        newEmail,
        newWebsite,
        newAvatar,
        newPhone,
        newMajor,
        newResearchField,
        newAcademicRank,
        newDegree,
        newTextbook,
        newJournal,
        newProject,
        newAchievements,
      },
    } = this.state;

    const data = {};
    if (newPassword.value !== '' && newPassword.value) data.password = newPassword.value;
    if (newFullname.value !== fullname && newFullname.value !== '' && newFullname.value) data.fullname = newFullname.value;
    if (newAcademicRank.value !== academicRank && newAcademicRank.value !== '' && newAcademicRank.value) data.academicRank = newAcademicRank.value;
    if (newPhone.value !== phone && newPhone.value !== '' && newPhone.value) data.phone = newPhone.value;
    if (newDegree.value !== degree && newDegree.value !== '' && newDegree.value) data.degree = newDegree.value;
    if (newMajor.value !== major && newMajor.value !== '' && newMajor.value) data.major = newMajor.value;
    if (newJournal.value !== journal && newJournal.value !== '' && newJournal.value) data.journal = newJournal.value;
    if (newTextbook.value !== textbook && newTextbook.value !== '' && newTextbook.value) data.textbook = newTextbook.value;
    if (newProject.value !== project && newProject.value !== '' && newProject.value) data.project = newProject.value;
    if (newAchievements.value !== achievements && newAchievements.value !== '' && newAchievements.value) data.achievements = newAchievements.value;
    if (newResearchField.value !== researchField && newResearchField.value !== '' && newResearchField.value) {
      data.researchField = newResearchField.value;
    }
    if (newEmail.value !== email && newEmail.value !== '' && newEmail.value) data.email = newEmail.value;
    if (newWebsite.value !== website && newWebsite.value !== '' && newWebsite.value) data.website = newWebsite.value;
    if (newAvatar.value !== avatar && newAvatar.value !== '' && newAvatar.value) data.avatar = newAvatar.value;

    this.props.updateInfo({
      lecturerId,
      data,
      response: {
        success: async () => {
          this.closeCofirmModal();
          message.success('Thay đổi hồ sơ thành công');
        },
        failure: async (msg = 'Thay đổi hồ sơ không thành công') => {
          this.closeCofirmModal();
          message.error(msg);
        },
      },
    });
  }

  render() {
    const { fields, confirmModalVisible } = this.state;
    const { formItemLayout, tailFormItemLayout, info } = this.props;
    const {
      newPassword,
      newFullname,
      newEmail,
      newWebsite,
      newAvatar,
      newMajor,
      newAcademicRank,
      newPhone,
      newResearchField,
      newDegree,
      newJournal,
      newProject,
      newTextbook,
      newAchievements,
    } = fields;
    const isValid = newPassword.value !== '' ||
                    (newFullname.value !== info.fullname && newFullname.value !== '') ||
                    (newAcademicRank.value !== info.position) ||
                    (newPhone.value !== info.phone) ||
                    (newMajor.value !== info.major) ||
                    (newDegree.value !== info.department) ||
                    (newJournal.value !== info.journal) ||
                    (newProject.value !== info.project) ||
                    (newTextbook.value !== info.textbook) ||
                    (newResearchField.value !== info.researchField) ||
                    (newEmail.value !== info.email) ||
                    (newWebsite.value !== info.website) ||
                    (newAvatar.value !== info.avatar) ||
                    (newAchievements.value !== info.achievements);

    return (
      <div>
        <ProfileForm
          {...fields}
          onChange={this.handleFormChange}
          isValid={isValid}
          showConfirmModal={this.showConfirmModal}
          formItemLayout={formItemLayout}
          tailFormItemLayout={tailFormItemLayout}
        />
        {confirmModalVisible && <ConfirmModal
          handleConfirm={this.handleConfirm}
          handleClose={this.closeCofirmModal}
          formItemLayout={formItemLayout}
          tailFormItemLayout={tailFormItemLayout}
        />}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  info: state.user.info,
  upload: state.upload,
});

const mapDispatchToProps = {
  updateInfo,
  uploadFile,
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);



// WEBPACK FOOTER //
// ./src/screens/Dashboard/Categories/Profile/Profile.js